import { TemplateRef } from '@angular/core';

export class ObjectHelper {
  public static deepCopy<T>(obj: T): T {
    const seen = new WeakMap();

    function clone(value: any): any {
      if (value === null || typeof value !== 'object') return value;
      if (value instanceof Date) return new Date(value);
      if (value instanceof Map) return new Map([...value.entries()]);
      if (value instanceof Set) return new Set([...value]);
      if (value instanceof TemplateRef) return value; // keep Angular references intact
      if (typeof value === 'function') return value;

      if (seen.has(value)) return seen.get(value);

      const result = Array.isArray(value)
        ? []
        : Object.create(Object.getPrototypeOf(value));
      seen.set(value, result);

      for (const key of Object.keys(value)) {
        result[key] = clone(value[key]);
      }

      return result;
    }

    return clone(obj);
  }
}
